module.exports = __webpack_public_path__ + "img/unlock-button-red-01.f32ffe45.png";